import * as types from "../actionTypes";

export function toggleMusic() {
  return { type: types.TOGGLE_MUSIC };
}

export function setWsConnection(payload) {
  return { type: types.SET_WS_CONNECTION, payload };
}